import { Deserializable } from './deserializable.model';

export class FirstVisit implements Deserializable<any, FirstVisit> {
  constructor(
    public clearedIoNotifications = false,
    public checkInCount = 0,
    public collapsedChallengeInfoIndividual = false,
    public collapsedChallengeInfoGroup = false,
    public completedReflection = false,
    public dismissedAccountCreationModal = false,
    public discover = false,
    public firstActionAdded = false,
    public firstQuestAdded = false,
    public firstTimeAppVisit = false,
    public initialDailyChallenge = false,
    public lastModalLaunch: string = new Date(0).toISOString(),
    public notificationPrompt = false,
    public progress = false,
    public reminders = false,
    public purposefulVisits = 0, // Starts counting after acknowledging Today first visit messages
    public resourcefulVisits = 0,
    public shownExpandedLiveSupport = false,
    public shownCrossPromotionModal = false,
    public shownNotificationsModal = false,
    public shownPurposefulFeedbackModal = false,
    public shownResourcefulFeedbackModal = false,
    public today = false,
    public webMigrated = false
  ) {}

  deserialize(json?: any, previousValue?: FirstVisit): FirstVisit {
    if (json != null || previousValue != null) {
      Object.assign(this, previousValue || {}, json);
    }
    return this;
  }
}
